import Movements from '@/components/movements/Movements'
import MovementDetail from '@/components/movements/MovementDetail'
import MovementCreate from '@/components/movements/MovementCreate'
import MovementUpdate from '@/components/movements/MovementUpdate'

const movementsRoutes = [
  { path: '/movements', name: 'movements', component: Movements },
  { path: '/movement/create', name: 'movement_create', component: MovementCreate },
  { path: '/movement/update/:id', name: 'movement_update', component: MovementUpdate },
  { path: '/movement/:id', name: 'movement', component: MovementDetail }
]

export default movementsRoutes



// WEBPACK FOOTER //
// ./src/router/movements_routes.js